import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as global from "../data/global";
import { openSiteWindow, SITE_WINDOW_IDS } from "./windowChrome/index.js";

/** /inventory now opens the same Site Inventory modal as the main menu (inline expand/edit). */
const InventoryWindow = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const guid = global.gw.selectedSite?.siteGuid || null;
        navigate("/sites", { replace: true });
        openSiteWindow(SITE_WINDOW_IDS.inventory, guid);
    }, [navigate]);

    return null;
};

export default InventoryWindow;
